import styled from 'styled-components';

import { px } from '../../../../contrib/ui';
import { IProps } from './EmptyList';

export const EmptyListStyled = styled.div<IProps>`
  height: ${p => (p.itemHeight ? px(p.itemHeight) : 'auto')};
`;
